import React from 'react';

import { Button, Stack } from '@mui/material';

import { useMRTState } from '../../../hooks/useMRTState';

import SystemTabs from '../../../ui/SystemTabs';

import TabCabecalho from './tabs/TabCabecalho';
import TabCertificado from './tabs/TabCertificado';

import useDadosEmpresaModule from './modules/useDadosEmpresaModule';
import useCertificadoModule from './modules/useCertificadoModule';
import useCadastroCertificadoModule from './modules/useCadastroCertificadoModule';

function Form(props) {
    const {
        dados,
        handleSubmit,
        btnText,
        caminhoVoltar,

        EnumTipo,
        EnumRamoAtividade,
        ufs,
        OptionsMatriz,

        navigate,
        params,
        parametro,
        setFlashMessage,
        setDados,
    } = props;

    const context = {
        empresa: dados,
        empresaId: dados?.id,
    };

    //table state
    const mrt = useMRTState({
        storageKey: 'empresa-certificado',
        pageSizeDefault: parametro?.paginacao ?? 5,
    });

    const dadosEmpresaModule = useDadosEmpresaModule({ ...props, context });
    const certificadoModule = useCertificadoModule({ ...props, context, mrt });
    const cadastroCertificadoModule = useCadastroCertificadoModule({
        context,
        setFlashMessage,

        fecharDialog: certificadoModule.actions.fecharDialog,

        atualizar: certificadoModule.actions.atualizar,
    });
    const tabsConfig = [
        {
            key: 'cabecalho',
            label: 'Dados da Empresa',
            title: 'Dados da Empresa',
            panel: (
                <TabCabecalho
                    module={dadosEmpresaModule}
                    EnumTipo={EnumTipo}
                    EnumRamoAtividade={EnumRamoAtividade}
                    ufs={ufs}
                    OptionsMatriz={OptionsMatriz}
                />
            ),
        },
        {
            key: 'certificado',
            label: 'Certificados Digitais',
            title: 'Certificados Digitais da Empresa',
            panel: <TabCertificado module={certificadoModule} cadastroModule={cadastroCertificadoModule} mrt={mrt} />,
        },
    ];

    const submit = (event) => {
        event.preventDefault();
        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Gestão de Empresas</h1>

            <SystemTabs tabs={tabsConfig} initialKey="cabecalho" />

            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" type="button" onClick={() => navigate(caminhoVoltar, params)}>
                        Voltar
                    </Button>

                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}

export default Form;
